<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>
                        <span
                            class="cursor-pointer me-1"
                            :style="{ color: allSelected ? '#28a745' : '#b0b0b0' }"
                            @click="toggleSelectAll(! allSelected)"
                        >
                            <i class="fas fa-check-circle"></i>
                        </span>
                        Name
                    </th>
                    <th>Invoice Date</th>
                    <th>Invoice NO</th>
                    <th class="text-right">Invoice Amount</th>
                    <th class="text-center">VDS</th>
                    <th class="text-center">AIT</th>
                    <th class="text-center">Discount</th>
                    <th class="text-right">Already Received</th>
                    <th class="text-right">Already Adjusted</th>
                    <th class="text-right">Due</th>
                    <th class="text-right">Received Now</th>
                </tr>
                </thead>
                <tbody>

                <template v-for="(item, i) in dueBills" :key="i">
                    <ClientWiseDueTableRow :item="item"/>
                </template>

                <tr>
                    <td colspan="9" class="text-right"><h4>Total Receive</h4></td>
                    <td class="text-right">
                        {{ total }}
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="!dueBills.length" class="text-center mt-5">No due bills found</p>
        </div>
    </div>
</template>

<script setup>
import ClientWiseDueTableRow from '@/components/molecule/company/inventory/pending-money-receipt-clientwise/ClientWiseDueTableRow.vue'
import { computed } from 'vue'

const emits = defineEmits(['updateTotal']);
const props = defineProps({
    dueBills: {
        type: Array,
        default: () => []
    }
})

const allSelected = computed(() => {
    if (!props.dueBills.length) return false
    return props.dueBills.every(item => item.selected === true)
})

const toggleSelectAll = (checked) => {
    props.dueBills.forEach(item => {
        item.selected = checked
        item.payment = checked ? item.due : 0
    })
}

const total = computed(() => {
    const totalAmount = props.dueBills
        .filter(item => item.selected)
        .reduce((sum, { payment }) => sum + Number(payment), 0)
    emits('updateTotal', totalAmount);
    return totalAmount
})
</script>
